import React from 'react'
import Layout from './Layout'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'

const CheckoutResultV2 = () => {

    // get state from useparams
    const { checkoutState } = useParams();

    const [pageTitle, setPageTitle] = React.useState("");
    const [message, setMessage] = React.useState("");

    return (
        <Layout>
            <div className="bg-white pt-5 py-5">


                {checkoutState == "success" ? (
                    <div className="  mt-5">
                        <h1 className="text-xl  text-center text-green-800 ">Merci pour votre paiement !</h1>
                        <p className="text-center">Votre paiement a été effectué avec succès.</p>
                    </div>
                ) : checkoutState == "error" ? (
                    <div className="  mt-5">
                        <h1 className="text-xl text-center text-red-600">Erreur de paiement</h1>
                        <p className="text-center">Votre paiement a échoué. Veuillez réessayer.</p>
                    </div>
                ) : (
                    <div className="  mt-5">
                        <h1 className="text-center">État de la commande inconnu</h1>
                        <p className="text-center">Veuillez contacter le support.</p>
                    </div>
                )}
                <div className="  mt-5">
                    <h1 className="text-center">État de la commande : {checkoutState}</h1>
                    <p className="text-center">Veuillez contacter le support.</p>
                </div>
            </div>
        </Layout>
    )
}

export default CheckoutResultV2